import * as Moment from 'moment';
import { IFormatter } from '../interfaces';

interface IDateFormatterOptions {
  format?: string;
}

const possibleInputFormats = [
  'YYYY-MM-DDTHH:mm:ss',
  'DD-MM-YYYY',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DD'
];

export class DateFormatter implements IFormatter<IDateFormatterOptions> {
  name = 'date';

  format(input: string, options: IDateFormatterOptions = { format: 'DD-MM-YYYY' }): string {

    if (!input) {
      return '';
    }

    if (input == '0001-01-01T00:00:00') {
      return '';
    }

    let validDate: Moment.Moment = null;

    // use 'some' to break when found
    possibleInputFormats.some(format => {
      const checkDate = Moment(input, format, true);
      if (checkDate.isValid()) {
        validDate = checkDate;
        return true;
      }

      return false;
    });

    if (!validDate) {
      return '';
    }

    return validDate.format(options.format);
  }
}
